module.exports = __webpack_public_path__ + "img/covid.1cc066a1.png";